var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedEnvelopeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 257,
    viewBox: "0 0 478 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46111_447424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.775 256.524C18.775 256.524 -23.4486 192.244 22.7619 122.652C63.7628 60.9063 128.454 110.004 165.109 47.1748C215.099 -38.5068 464.566 -5.04549 432.973 126.779C417.683 190.572 502.363 192.891 470.863 256.66L18.775 256.524Z",
    fill: "#EBF3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.934 128.075C333.934 128.075 326.307 117.954 334.406 112.336C334.406 112.336 340.258 109.271 344.839 109.837C344.839 109.837 337.641 120.363 339.682 121.584C341.721 122.803 346.856 109.275 346.856 109.275C346.856 109.275 359.765 108.832 363.769 111.076C363.769 111.076 352.239 119.375 354.516 120.054C356.793 120.734 369.191 112.655 369.191 112.655C369.191 112.655 381.007 115.435 379.914 122.687C378.822 129.939 374.568 131.933 372.772 131.628C370.976 131.32 360.647 126.617 360.325 128.085C360.003 129.554 366.068 134.799 370.513 135.306C370.513 135.306 361.513 144.074 356.086 141.041C350.658 138.009 350.445 133.728 347.056 131.915C343.667 130.103 340.69 129.921 342.028 131.637C343.366 133.354 349.581 135.329 351.355 138.985C353.13 142.642 354.77 145.136 349.035 143.902C343.3 142.668 334.155 137.841 334.044 132.959C333.934 128.075 333.934 128.075 333.934 128.075Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.034 122.517C374.034 122.517 341.676 119.239 333.934 128.075C333.934 128.075 332.054 132.726 326.908 136.745L326.02 138.77C326.02 138.77 332.011 133.191 334.045 132.957C334.045 132.957 331.617 121.258 374.034 122.517Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.909 136.746C326.909 136.746 319.626 141.464 318.566 150.643L319.822 150.835C319.822 150.835 322.639 141.453 326.89 137.98C331.143 134.507 326.909 136.746 326.909 136.746Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.512 143.882C276.512 143.882 259.601 134.403 267.493 121.539C267.493 121.539 273.806 113.641 280.57 111.608C280.57 111.608 276.962 130.792 280.57 131.244C284.177 131.695 283.05 109.578 283.05 109.578C283.05 109.578 300.863 101.001 307.854 101.679C307.854 101.679 296.805 120.412 300.414 119.96C304.021 119.509 316.423 100.551 316.423 100.551C316.423 100.551 334.687 97.1658 337.618 107.998C340.549 118.831 335.814 124.248 333.109 124.925C330.403 125.601 313.041 125.376 313.492 127.634C313.943 129.891 325.667 133.501 332.207 131.471C332.207 131.471 324.991 149.3 315.521 148.397C306.05 147.494 303.119 141.626 297.256 141.175C291.394 140.723 287.11 142.303 290.041 143.884C292.972 145.463 302.894 144.402 307.628 148.43C312.363 152.459 316.196 154.943 307.403 156.747C298.61 158.553 282.826 157.424 279.668 150.653C276.512 143.882 276.512 143.882 276.512 143.882Z",
    fill: "#A8D29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.272 111.382C329.272 111.382 281.922 126.729 276.509 143.881C276.509 143.881 276.735 151.554 272 160.356V163.741C272 163.741 276.96 152.231 279.667 150.651C279.667 150.653 269.069 135.757 329.272 111.382Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 160.357C272 160.357 264.697 171.456 268.861 184.967L270.74 184.463C270.74 184.463 268.916 169.582 272.737 162.097C276.559 154.612 272 160.357 272 160.357Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.334 138.739C227.334 138.739 247.014 130.402 239.922 115.348C239.922 115.348 233.959 105.926 226.793 102.88C226.793 102.88 228.424 124.339 224.416 124.397C220.407 124.453 224.322 100.353 224.322 100.353C224.322 100.353 205.839 88.7943 198.097 88.6868C198.097 88.6868 207.936 110.555 204.038 109.622C200.139 108.689 188.844 86.4095 188.844 86.4095C188.844 86.4095 169.24 80.484 164.716 91.9993C160.192 103.515 164.726 110.026 167.609 111.096C170.493 112.166 189.546 114.025 188.778 116.442C188.01 118.86 174.724 121.396 167.804 118.377C167.804 118.377 173.553 138.792 184.039 138.951C194.526 139.109 198.449 133.035 204.929 133.252C211.408 133.468 215.912 135.719 212.508 137.095C209.104 138.471 198.361 136.103 192.684 139.945C187.007 143.786 182.506 146.042 191.924 149.087C201.342 152.131 218.775 152.809 223.054 145.773C227.334 138.739 227.334 138.739 227.334 138.739Z",
    fill: "#A8D29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.449 96.7241C173.449 96.7241 223.481 119.287 227.335 138.739C227.335 138.739 226.158 147.12 230.282 157.341L229.872 161.05C229.872 161.05 225.829 147.835 223.057 145.776C223.055 145.776 236.472 130.738 173.449 96.7241Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.283 157.341C230.283 157.341 236.941 170.389 230.744 184.691L228.746 183.91C228.746 183.91 232.546 167.824 229.267 159.158C225.984 150.492 230.283 157.341 230.283 157.341Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.967 157.118C163.489 152.097 163.1 147.42 163.1 147.42C163.1 147.42 172.723 140.504 167.051 133.232C167.051 133.232 162.676 128.866 158.429 128.097C158.429 128.097 161.932 139.501 159.773 140.022C157.612 140.543 156.785 127.033 156.785 127.033C156.785 127.033 145.38 123.044 141.181 123.934C141.181 123.934 149.173 134.555 146.951 134.528C144.729 134.502 135.901 123.837 135.901 123.837C135.901 123.837 124.576 123.031 123.537 129.812C122.498 136.592 125.744 139.558 127.433 139.784C129.123 140.011 139.653 138.684 139.532 140.085C139.414 141.486 132.538 144.483 128.428 143.697C128.428 143.697 134.029 154.032 139.719 152.834C145.41 151.637 146.789 147.873 150.318 147.196C153.848 146.52 156.559 147.186 154.885 148.347C153.213 149.508 147.115 149.542 144.514 152.313C141.913 155.085 139.756 156.855 145.22 157.349C150.684 157.844 160.194 156.077 161.648 151.748C161.711 151.559 161.772 151.379 161.83 151.207C161.752 151.559 161.648 151.748 161.648 151.748C162.699 152.212 164.485 154.789 165.747 156.779C165.934 157.121 166.222 157.591 166.64 158.224C166.813 158.512 166.952 158.748 167.049 158.914C169.463 163.417 169.382 171.671 169.382 171.671L170.559 171.85C172.161 163.359 166.967 157.118 166.967 157.118Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.85 132.678V255.785H148.406V132.678L251.128 194.232L353.85 132.678Z",
    fill: "#FF9843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.406 255.785L242.504 188.26C247.659 184.56 254.596 184.56 259.751 188.26L353.849 255.785H148.406Z",
    fill: "#ED7D2B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_46111_447424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353 133.001L259.563 200.238C254.444 203.922 247.556 203.922 242.437 200.238L149 133.001L353 133.001Z",
    fill: "#FF9843"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.455 31.7183L256.311 51.2761L223.673 66.0842L214.816 46.5264L235.564 48.9012L247.455 31.7183Z",
    fill: "#CDE0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.816 46.5264L247.455 31.7183L237.697 48.1802C236.927 49.4784 235.435 50.1647 233.95 49.9018L214.816 46.5264Z",
    fill: "#B1CFF2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5712 159.426L60.2306 171.932L39.3609 179.722L34.7031 167.216L47.4669 169.574L55.5712 159.426Z",
    fill: "#CDE0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7031 167.216L55.5729 159.426L48.8217 169.218C48.2897 169.991 47.3347 170.351 46.4243 170.126L34.7031 167.216Z",
    fill: "#B1CFF2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.955 84.9956L406.407 109.551L365.43 98.6063L371.976 74.0508L389.193 91.801L412.955 84.9956Z",
    fill: "#CDE0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.977 74.0508L412.954 84.9956L391.685 92.742C390.008 93.3522 388.127 92.8611 386.964 91.5049L371.977 74.0508Z",
    fill: "#B1CFF2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.254 34.1115L327.842 38.3238L310.345 25.9897L309.386 29.8431L302.888 30.9181L301.254 34.1115Z",
    fill: "#AFCDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.841 38.3236L305.842 26.5403L284.125 25.1147L327.841 38.3236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.344 25.9896L327.841 38.3236L314.441 19.2603L310.344 25.9896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.19 255.628H433.275C432.315 254.812 433.939 252.962 435.636 252.838C436.373 252.782 437.304 252.937 438.37 253.162C438.616 249.884 440.024 235.15 445.329 235.742C451.296 236.406 445.329 242.23 443.642 245.68C442.393 248.235 441.075 251.898 440.473 253.627C440.958 253.732 441.46 253.835 441.972 253.929C442.763 251.5 445.704 243.325 449.447 243.801C453.84 244.359 452.074 247.637 448.961 249.581C446.676 251.012 443.872 253.046 442.539 254.028C443.667 254.214 444.847 254.338 446.043 254.31C449.111 254.235 450.61 255.14 451.19 255.628Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6923 255.991C49.6923 255.991 42.8833 237.272 38.1017 238.868C33.32 240.464 49.6923 255.991 49.6923 255.991Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0868 255.992C46.5068 255.992 35.6416 244.705 34.9162 247.66C34.1909 250.615 47.0868 255.992 47.0868 255.992Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6757 255.991C58.6757 255.991 54.1815 251.867 48.4911 252.94C42.8007 254.013 40.3719 255.189 36.798 254.375C33.2242 253.562 31.3984 255.99 31.3984 255.99H58.6757V255.991Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.471 257.053H0.592724C0.295316 257.053 0.0507812 256.81 0.0507812 256.511V256.326C0.0507812 256.028 0.293664 255.783 0.592724 255.783H477.471C477.768 255.783 478.013 256.026 478.013 256.326V256.511C478.013 256.81 477.768 257.053 477.471 257.053Z",
    fill: "#FE978E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_46111_447424",
    x: 143,
    y: 125.001,
    width: 224,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_46111_447424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_46111_447424",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46111_447424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 478,
    height: 257,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEnvelopeImage);
export default __webpack_public_path__ + "static/media/closed-envelope-image.233b6d83e55a082872065112370da8e3.svg";
export { ForwardRef as ReactComponent };